import Vue from 'vue'
import Vuex from 'vuex'
// Modules
import account from './modules/account'
import auth from './modules/auth'
import customer from './modules/customer'
import dashboard from './modules/dashboard'
import excel from './modules/excel'
import order from './modules/order'
import orderDetail from './modules/order-detail'
import product from './modules/product'
import tool from './modules/tool'
import textmessages from './modules/textmessages'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    account,
    auth,
    customer,
    dashboard,
    excel,
    order,
    orderDetail,
    product,
    tool,
    textmessages
  }
})
